// extracted by mini-css-extract-plugin
export default {"factorSetup":"factor-setup_factorSetup__mxHJ0","setupDescription":"factor-setup_setupDescription__qvnys","stepLabel":"factor-setup_stepLabel__2Y2RR"};